import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
  HttpBackend,
} from "@angular/common/http";
import { environment } from "./../../../environments/environment";
import { BehaviorSubject, of, throwError } from "rxjs";
import { Observable } from "rxjs";
import { catchError, finalize, share, tap, timeout } from "rxjs/operators";
import * as moment from "moment-timezone";
import { CurrencyPipe } from "@angular/common";
//import { ToastrService } from 'ngx-toastr';
import { HttpErrorHandlerService } from './http-error-handler.service';
import { map } from "rxjs/operators";
import { GatewayConfigService } from './gateway-config.service';

// Offer Options API Interfaces
interface OfferTableRow {
  row_label: string;
  SBF: string;
  CLF: string;
}

interface OfferOptionsData {
  title_content: string;
  sub_title_content: string;
  table_content: OfferTableRow[];
  special_note_content: string;
  apply_question_content: string;
  apply_question_yes_content: string;
  apply_question_no_content: string;
  disclosure_content: string;
  continue_sbf_btn_content: string;
  continue_clf_btn_content: string;
}

interface OfferOptionsApiResponse {
  status: string;
  data: OfferOptionsData;
}

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  showCoverDashIframe = false
  globalDataLoader: boolean = false;
  private prepayInFlight = false;
  private drawInFlight = false;
  private hideRewardsSubject = new BehaviorSubject<boolean>(true);
  hideRewards$ = this.hideRewardsSubject.asObservable();
  prepayResult$ = new BehaviorSubject<any>(null);
  //to  use of rxjs/behaviorsubject
  showNotifsCount = false;
  accountStatementState = {
    spendingLimit: undefined,
    discountedBalance: undefined,
    pendingAmount: undefined,
    spendingAvailability: undefined,
    dailySpendLimit: undefined,
    ministatement: [],
    currentTransactions: [],
    paymentCaledarHistoryData: undefined
  }
  updateAccountStatementState(spendingLimit = undefined, discountedBalance = undefined, pendingAmount = undefined, spendingAvailability = undefined, dailySpendLimit = undefined, ministatement = [], currentTransactions = [], paymentCaledarHistoryData = undefined) {
    //alias names/variables
    // availableCredit == spendingAvailability ->res.RevAccountSummary.limit.maxFundLimit
    // curentBalance == discountedBalance -> res.RevAccountSummary.summary.payNowBal
    this.accountStatementState = {
      spendingLimit: spendingLimit,
      discountedBalance: discountedBalance,
      pendingAmount: pendingAmount,
      spendingAvailability: spendingAvailability,
      dailySpendLimit: dailySpendLimit,
      ministatement: ministatement,
      currentTransactions: currentTransactions,
      paymentCaledarHistoryData: paymentCaledarHistoryData
    }
    this.globalDataLoader = false;
    return this.accountStatementState;
  }

  unsetAccountStatementState() {
    this.accountStatementState = {
      spendingLimit: undefined,
      discountedBalance: undefined,
      pendingAmount: undefined,
      spendingAvailability: undefined,
      dailySpendLimit: undefined,
      ministatement: [],
      currentTransactions: [],
      paymentCaledarHistoryData: undefined
    }
    this.unsetCacheData().subscribe(
      (res: any) => {
        console.log("cache unset success!");
      },
      () => {
        console.log("cache unset failed!");
      }
    );

    this.globalDataLoader = false;
    return this.accountStatementState;
  }

  getRandom() {
    return Math.floor(Math.random() * 1000000000);
  }

  getFormattedAmount(amount: any) {
    return this.currencyPipe.transform(amount || 0, "$");
  }
  getTitleForHistory(arg: any): string {
    if (arg && arg.pmtCode) {
      if (arg.pmtCode === "I") {
        return "Invalid";
      } else if (arg.pmtCode === "P") {
        return "Paid";
      } else if (arg.pmtCode === "U") {
        return "Uncleared";
      } else if (arg.pmtCode === "K") {
        return "Revoked";
      } else if (arg.pmtCode === "A") {
        return "Adjustment";
      } else if (arg.pmtCode === "L") {
        return "Partial";
      } else if (arg.pmtCode === "B") {
        return "Bounced";
      } else if (arg.pmtCode === "F") {
        return "MiscFee";
      } else if (arg.pmtCode === "E") {
        return "Error";
      } else if (arg.pmtCode === "S") {
        return "Suspended";
      } else if (arg.pmtCode === "C") {
        return "Collection";
      } else if (arg.pmtCode === "N") {
        return "Note";
      } else if (arg.pmtCode === "T") {
        return "Task";
      } else if (arg.pmtCode === "X") {
        return "Uncleared PayNow";
      } else if (arg.pmtCode === "Y") {
        return "Paid";
      } else if (arg.pmtCode === "D") {
        return "MCADraw";
      } else if (arg.pmtCode === "R") {
        return "Refund";
      } else if (arg.pmtCode === "W") {
        return "Rewards";
      } else {
        return "NA";
      }
    } else {
      return "NA";
    }
  }
  checkIsVisible(arg: any): boolean {
    let isVisible = true;
    if (arg && arg.pmtCode) {
      if (arg.pmtCode === "U") {
        isVisible = false;
      } else if (arg.pmtCode === "D") {
        isVisible = false;
      } else if (arg.pmtCode === "N") {
        isVisible = false;
      } else if (arg.pmtCode === "T") {
        isVisible = false;
      } else if (arg.pmtCode === "X") {
        isVisible = false;
      } else if (arg.pmtCode === "W") {
        isVisible = false;
      }
    }
    return isVisible;
  }

  getIsVisibleCount(arr: any) {
    let isVisibleCount = 0;

    try {
      arr.forEach((arg: { pmtCode: string; }) => {
        if (arg && arg.pmtCode) {
          if (arg.pmtCode === "U") {
          } else if (arg.pmtCode === "D") {

          } else if (arg.pmtCode === "N") {

          } else if (arg.pmtCode === "T") {

          } else if (arg.pmtCode === "X") {

          } else if (arg.pmtCode === "W") {

          } else {
            //hehehe
            isVisibleCount++;
          }
        }
      });
    } catch (error) {
      //do-nothing
    }

    return isVisibleCount;
  }
  unsetCacheData(): any {
    // localStorage.setItem("cacheData", JSON.stringify(data));
    let postData = {
      email: window.localStorage.getItem("email"),
      token: JSON.parse(window.localStorage.getItem("token") || "").access_token,
      data: " "
    }
    /*cache implementation*/
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;

    return this.http
      .post(`${environment.baseUrl}v1/cache/unsetUserCacheData`, postData, {
        headers: new HttpHeaders()
          // .set("skip_interceptor", "true")
          .set("skip_interceptor_rum_logs", "true")
          .append("appname", environment.appName)
          .append("Access-Control-Allow-Methods", "POST")
          .append("Access-Control-Allow-Origin", "*")
          .append("Authorization", "Bearer " + idToken)
          .append(
            "Access-Control-Allow-Headers",
            "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
          )
      });

    /*cache implementation*/
  }
  setCacheData(data: any): any {
    // localStorage.setItem("cacheData", JSON.stringify(data));
    let postData = {
      email: window.localStorage.getItem("email"),
      token: JSON.parse(window.localStorage.getItem("token") || "").access_token,
      data: data
    }
    /*cache implementation*/
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;

    return this.http
      .post(`${environment.baseUrl}v1/cache/setUserCacheData`, postData, {
        headers: new HttpHeaders()
          .set("skip_interceptor", "true")
          .set("skip_interceptor_rum_logs", "true")
          .append("Access-Control-Allow-Methods", "POST")
          .append("Access-Control-Allow-Origin", "*")
          .append("appname", environment.appName)
          .append("Authorization", "Bearer " + idToken)
          .append(
            "Access-Control-Allow-Headers",
            "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
          )
      });

    /*cache implementation*/
  }

  setPrimaryContactPreference(email: any, preference: string): any {
    const body = {
      email: email,
      metadata: {
        primary_contact_preference: preference
      }
    };

    const idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;

    return this.http
      .post(`${environment.baseUrl}v1/authentication/setPrimaryContactPreferenceInUserMetaData`, body, {
        headers: new HttpHeaders()
          .set("appname", "revenued_middleware_token")
          .set("Authorization", "Bearer " + idToken)
          .set("Content-Type", "application/json")
      });
  }

  updateProfile(body: any): any {
    const idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;

    return this.http.post(`${environment.baseUrl}v1/authentication/updateProfileInUserMetaData`, body, {
      headers: new HttpHeaders()
        .set("Authorization", "Bearer " + idToken)
        .set("Content-Type", "application/json")
        .set("appname", "revenued_middleware_token")
    });
  }

  //to  use of rxjs/behaviorsubject

  private cache: any;
  private cachedObservable!: Observable<any>;

  //to bypass the global http interceptor
  //http: HttpClient;
  constructor(handler: HttpBackend, private http: HttpClient,

    private currencyPipe: CurrencyPipe,
    private httpErrorHandler: HttpErrorHandlerService,
    private gatewayConfigService: GatewayConfigService
    // private toastr: ToastrService
  ) {
    //to bypass the global http interceptor
    // this.http = new HttpClient(handler);
  }
  searchTransactionsEvent = new BehaviorSubject("");
  private handleError = (error: HttpErrorResponse) => {
    // Handle special status codes using the error handler service
    if (this.httpErrorHandler.handleHttpError(error)) {
      return throwError(error);
    }

    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    console.log(error.message);
    // Return an observable with a user-facing error message.
    return throwError(
      error.error ||
      error.message ||
      "Something bad happened; please try again later."
    );
  }
  searchTransactions(searchKey: string) {
    this.searchTransactionsEvent.next(searchKey);
  }
  getSummary() {
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get("/assets/summary.xml", {
        headers: new HttpHeaders()
          .set("Content-Type", "text/xml")
          .append("skip_interceptor", "true")
          .append("Access-Control-Allow-Methods", "GET")
          .append("Access-Control-Allow-Origin", "*")
          .append(
            "Access-Control-Allow-Headers",
            "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
          ),
        responseType: "text",
      })
      .pipe(catchError(this.handleError));
  }

  getAccountSummary() {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || '{}').id_token;

    console.log('AccountService - getAccountSummary called', {
      oppId,
      hasToken: !!idToken,
      tokenLength: idToken?.length
    });

    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    // const endpoint = this.gatewayConfigService.getApiEndpoint('accountsummary', oppId); //later when all api's are move to /gw/
    let endpoint = `${environment.baseUrl}v1/revenued/accountsummary/${oppId}`;
    console.log('AccountService - Using endpoint:', endpoint);

    return this.http
      .get(endpoint, {
        headers: new HttpHeaders()
          .set("Content-Type", "text/xml")
          // .append('skip_interceptor', 'true')
          .append("Access-Control-Allow-Methods", "GET")
          .append("Access-Control-Allow-Origin", "*")
          .append(
            "Access-Control-Allow-Headers",
            "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
          )
          .append("appname", environment.appName)
          .append("Authorization", "Bearer " + idToken),
        responseType: "text" as "json",
      })
      .pipe(
        tap(
          response => console.log('AccountService - getAccountSummary response:', response),
          error => console.error('AccountService - getAccountSummary error:', error)
        ),
        catchError(this.handleError)
      );
  }
  
  getTransactionHistory(): any {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;

    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get(`${environment.baseUrl}v1/revenued/transactionhistory/${oppId}`, {
        headers: new HttpHeaders()
          .set("Content-Type", "text/xml")
          // .append('skip_interceptor', 'true')
          .append("Access-Control-Allow-Methods", "GET")
          .append("Access-Control-Allow-Origin", "*")
          .append(
            "Access-Control-Allow-Headers",
            "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
          )
          .append("appname", environment.appName)
          .append("Authorization", "Bearer " + idToken),
        responseType: "text" as "json",
      })
      .pipe(catchError(this.handleError));
  }


  getTransactionDetails(tid: string, oppId: any, idToken: string, appname: string | string[]): any {

    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get(`${environment.baseUrl}v1/revenued/transactiondetails/${oppId}?tid=` + tid, {
        headers: new HttpHeaders()
          .set("Content-Type", "text/xml")
          // .append('skip_interceptor', 'true')
          .append("Access-Control-Allow-Methods", "GET")
          .append("Access-Control-Allow-Origin", "*")
          .append(
            "Access-Control-Allow-Headers",
            "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
          )
          .append("appname", appname)
          .append("Authorization", "Bearer " + idToken),
        responseType: "text" as "json",
      })
      .pipe(catchError(this.handleError));
  }
  getPaymentDetails(pid: string, oppId: any, idToken: string, appname: string | string[]): any {
    return this.http
      .get(`${environment.baseUrl}v1/revenued/paymentdetails/${oppId}?pid=` + pid, {
        headers: new HttpHeaders()
          .set("Content-Type", "text/xml")
          // .append('skip_interceptor', 'true')
          .append("Access-Control-Allow-Methods", "GET")
          .append("Access-Control-Allow-Origin", "*")
          .append(
            "Access-Control-Allow-Headers",
            "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
          )
          .append("appname", appname)
          .append("Authorization", "Bearer " + idToken),
        responseType: "text" as "json",
      })
      .pipe(catchError(this.handleError));
  }
  getTransactionHistoryNew(
    pageIndex: number,
    pageSize: number,
    sortField: string | null,
    sortBy: string | null,
    sortOrder: string | null,
    filters: string
  ): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
     const body = {
      pageNo: pageIndex,
      pageRows: pageSize,
      sortFilter: sortField,
      whereClause: filters,
    };
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
      .append("pageNo", pageIndex ? `${pageIndex}` : "")
      .append("pageRows", pageSize ? `${pageSize}` : "")
      .append("sortFilter", sortField ? `${sortField}` : "")
      .append("sortBy", sortBy ? `${sortBy}` : "")
      .append("sortOrder", sortOrder ? `${sortOrder}` : "")

  
       const endpoint = this.gatewayConfigService.getApiEndpoint('transactionhistory', oppId);

    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(
         endpoint,
      // `${environment.baseUrl}v1/revenued/transactionhistory/${oppId}`,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }

  setDunsToOppId(data: any): any {
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/authentication/updateDuns?accId=${data.accId}&duns=${data.dunsId}&email=${data.email}`, {
      headers: {
        appname: data.appname || 'RevenuedUAT'
      }
    }).pipe(
      catchError(this.handleError)
    );
  }
  verifyBusiness(data: any): any {
    var oppId = window.localStorage.getItem('oppId');
    const idToken = JSON.parse(window.localStorage.getItem('token') ?? '')?.id_token;
    const headers = new HttpHeaders()
      .append('appname', environment.appName)
      .append("skip_interceptor", "true")
      .append('Authorization', 'Bearer ' + idToken);
    return this.http.post<{ results: any[] }>(`${environment.baseUrl}v1/submission/searchBusiness`, { ...data }, { headers }).pipe(
      catchError(this.handleError)
    );
  }

  shouldShowDuns() {
    const idToken = JSON.parse(window.localStorage.getItem('token') ?? '')?.id_token;
    const email = window.localStorage.getItem('email');

    const headers = {
      appname: environment.appName,
      Authorization: "Bearer " + idToken,
      skip_interceptor: "true",
    };
    //handle-from-global-interceptor
    return this.http.post(`${environment.baseUrl}v1/authentication/issetDuns`, { email },
      { headers },
    )
  };
  getTransactionHistoryIframe(
    pageIndex: number,
    pageSize: number,
    sortField: string | null,
    filters: string,
    oppId: string,
    idToken: string,
    appname: string
  ): Observable<any> {
    const body = {
      pageNo: pageIndex,
      pageRows: pageSize,
      sortFilter: sortField,
      whereClause: filters,
    };
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      // .append("skip_interceptor", "true")
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", appname)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
      .append("pageNo", pageIndex ? `${pageIndex}` : "")
      .append("pageRows", pageSize ? `${pageSize}` : "")
      .append("sortFilter", '-trxn.recDate')
      .append("whereClause", filters ? `${filters}` : "")
      .append("sortBy", 'trxn.effDate')
      .append("sortOrder", 'desc');
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
       const endpoint = this.gatewayConfigService.getApiEndpoint('transactionhistory', oppId);
    return this.http
      .get<{ results: any[] }>(
        // `${environment.baseUrl}v1/revenued/transactionhistory/${oppId}`,
        endpoint,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }

  getPaymentCalendarRecords(): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      // .append('skip_interceptor', 'true')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams();

    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    const endpoint = this.gatewayConfigService.getApiEndpoint('getPaymentCalendar', oppId);
    return this.http
      .get<{ results: any[] }>(
        endpoint,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }

  getPaymentCalendarHistory(begDate: string, endDate: string): Observable<any> {
    var oppId = window.localStorage.getItem('oppId');
    var idToken = JSON.parse(window.localStorage.getItem('token') || '').id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      // .append('skip_interceptor', 'false')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
      .append("begDate", begDate)
      .append("endDate", endDate);
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    const endpoint = this.gatewayConfigService.getApiEndpoint('getPaymentCalendarHistory', oppId);
    return this.http
      .get<{ results: any[] }>(
        endpoint,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }

  getPaymentCalendarHistoryIframe(begDate: string, endDate: string, oppId: any, idToken: string, appname: string | string[]): Observable<any> {

    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      // .append('skip_interceptor', 'true')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", appname)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
      .append("begDate", begDate)
      .append("endDate", endDate);
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    const endpoint = this.gatewayConfigService.getApiEndpoint('getPaymentCalendarHistory', oppId);
    return this.http
      .get<{ results: any[] }>(
        endpoint,
        // `${environment.baseUrl}v1/revenued/getPaymentCalendarHistoryIframe/${oppId}`,
        // `${environment.baseUrl}v1/revenued/getPaymentCalendarHistory/${oppId}`,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }


  requestRefiTerms(cardId: string, amount: string, caseId: string): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      .append("skip_interceptor", "true")
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
      .append("cardId", cardId)
      .append("caseId", caseId)
      .append("amount", amount);
       const endpoint = this.gatewayConfigService.getApiEndpoint('requestRefiTerms', oppId);

    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(
        endpoint
      //  `${environment.baseUrl}v1/revenued/requestRefiTerms/${oppId}`
        , {
        params,
        headers,
        responseType: "text" as "json",
      })
      .pipe(catchError(this.handleError));
  }

  requestRefi(cardId: string, amount: string, caseId: string): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      .append("skip_interceptor", "true")
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
      .append("cardId", cardId)
      .append("caseId", caseId)
      .append("amount", amount);
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/requestRefi/${oppId}`, {
        params,
        headers,
        responseType: "text" as "json",
      })
      .pipe(catchError(this.handleError));
  }

  requestDraw(cardId: any, amount: any, caseId: any, termsRequestId = ""): Observable<any> {
    if (this.drawInFlight) {
      return throwError(() => new Error('A Cash Draw request is already in progress. Duplicate request blocked.'));
    }
    this.drawInFlight = true;

    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      .append("skip_interceptor", "true")
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
      .append("cardId", cardId)
      .append("caseId", caseId)
      .append("amount", amount)
      .append("terms_request_id", termsRequestId);
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    const endpoint = this.gatewayConfigService.getApiEndpoint('requestDraw', oppId);

    return this.http
      .get<{ results: any[] }>(endpoint, {
        params,
        headers,
        responseType: "text" as "json",
      })
      .pipe(
        timeout(25000),
        finalize(() => { this.drawInFlight = false; }),
        catchError(this.handleError)
      );
  }

  createCase(data: any) {
    var oppId = window.localStorage.getItem("oppId");
    var submitter = window.localStorage.getItem("email");
    var idToken =
      window.localStorage.getItem("token") &&
        JSON.parse(window.localStorage.getItem("token") || "")
        ? JSON.parse(window.localStorage.getItem("token") || "").id_token
        : "";
    // const headers = { 'appname': window.localStorage.getItem('appName'), 'Authorization': 'Bearer ' + idToken, 'skip_interceptor': 'true' };
    const headers = new HttpHeaders({
      appname: environment.appName,
      Authorization: "Bearer " + idToken,
    })
    return this.http
      .post<{ results: any[] }>(
        `${environment.baseUrl}v1/logging/createCase`,
        { ...data, submitter, recordId: oppId, source: "Account Portal" },
        { headers }
      )
      .pipe(catchError(this.handleError));
  }

  updateCase(data: any) {
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    // const headers = { 'appname': window.localStorage.getItem('appName'), 'Authorization': 'Bearer ' + idToken, 'skip_interceptor': 'true' };

    const headers = new HttpHeaders({
      appname: environment.appName,
      Authorization: "Bearer " + idToken,
    })


    return this.http
      .post<{ results: any[] }>(
        `${environment.baseUrl}v1/logging/updateCase`,
        { ...data },
        { headers }
      )
      .pipe(catchError(this.handleError));
  }

  // logEvent(body: object) {
  //   const headers = { skip_interceptor: "true" };
  //   return this.http.post(`${environment.baseUrl}logEvent`, body, { headers });
  // }

  logEvent(body: object): Observable<any> {
    let observable: Observable<any>;
    if (this.cache) {
      observable = of(this.cache);
    } else if (this.cachedObservable) {
      observable = this.cachedObservable;
    } else {
      const appName = environment.appName;

      const headers = { skip_interceptor: "true", "appName": appName, };
      this.cachedObservable = this.http
        .post(`${environment.baseUrl}v1/logging/logEvent`, body, { headers })
        .pipe(
          tap((res) => (this.cache = res)),
          share(),
          finalize(() => (this.cachedObservable))
        );
      observable = this.cachedObservable;
    }
    return observable;
  }

  getPreDrawEstimates(
    cardId: string,
    amount: string,
    caseId: string
  ): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      .append("skip_interceptor", "true")
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
      .append("cardId", cardId)
      .append("caseId", caseId)
      .append("amount", amount);
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(
        `${environment.baseUrl}v1/revenued/getPreDrawEstimates/${oppId}`,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }

  getPreDrawEstimatesForOverLimit(
    cardId: string,
    amount: string,
    caseId: string
  ): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      // .append("skip_interceptor", "true")
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
      .append("cardId", cardId)
      .append("caseId", caseId)
      .append("amount", amount);
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    const endpoint = this.gatewayConfigService.getApiEndpoint('getPreDrawEstimatesForOverLimit', oppId);

    return this.http
      .get<{ results: any[] }>(
        endpoint,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }

  postCashDrawReject(
    cardId: string,
    amount: string,
    caseId: string,
    termsRequestId = ""
  ): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      .append("skip_interceptor", "true")
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
      .append("cardId", cardId)
      .append("caseId", caseId)
      .append("amount", amount)
      .append("terms_request_id", termsRequestId);
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    const endpoint = this.gatewayConfigService.getApiEndpoint('postCashDrawReject', oppId);

    return this.http
      .get<{ results: any[] }>(
        endpoint,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }

  revenuedTest(): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      .append("skip_interceptor", "true")
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams();
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/revenuedTest`, {
        params,
        headers,
        responseType: "text" as "json",
      })
      .pipe(catchError(this.handleError));
  }

  requestPrepay(
    achDate: string,
    cardId: string,
    amount: string,
    caseId: string
  ): Observable<any> {
    if (this.prepayInFlight) {
      return throwError(() => new Error('A PayNow request is already in progress. Duplicate request blocked.'));
    }
    this.prepayInFlight = true;

    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      // .append("skip_interceptor", "true")
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
      .append("cardId", cardId)
      .append("achDate", achDate)
      .append("caseId", caseId)
      .append("amount", amount);
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    const endpoint = this.gatewayConfigService.getApiEndpoint('requestPrepay', oppId);

    return this.http
      .get<{ results: any[] }>(
        endpoint
        // `${environment.baseUrl}v1/revenued/requestPrepay/${oppId}`
        , {
        params,
        headers,
        responseType: "text" as "json",
      })
      .pipe(
        timeout(25000),
        finalize(() => { this.prepayInFlight = false; }),
        catchError(this.handleError)
      );
  }

  getOppDetails(): Observable<any> {
    const oppId = window.localStorage.getItem('oppId') || '';
    const token = window.localStorage.getItem('token');
    const idToken = token ? JSON.parse(token).id_token : '';
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      // .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      .append('appname', environment.appName)
      .append('Authorization', 'Bearer ' + idToken);
    let params = new HttpParams()
      .append('oppId', oppId)
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/getOppDetails`, { params, headers, responseType: 'text' as 'json' }).pipe(
      tap((oppDetails: any) => {
        oppDetails = JSON.parse(oppDetails);
        this.hideRewardsSubject.next(oppDetails?.hideRewards);
      }),
      catchError(this.handleError)
    );
  }
  updateDuns(accId: string, duns: string, email: string): Observable<any> {
    const idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/authentication/updateDuns?accId=` + accId + `&duns=` + duns + `&email=` + email, {
      headers: new HttpHeaders()
        .set("Content-Type", "text/xml")
        .append("appname", environment.appName)
        .append("Authorization", "Bearer " + idToken)
    })
      .pipe(catchError(this.handleError));

  }
  getScoreResponse(oppId: string, loginDate: string): Observable<any> {
    const idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    const payload = {
      loginDate: loginDate,
      oppId: oppId
    };
    return this.http
      .post<{ results: any[] }>(
        `${environment.baseUrl}v1/submission/getScoreResponseByOppId`, payload,
        { headers }
      )
      .pipe(catchError(this.handleError));
  }

  getScoreResponseByOppId(): Observable<any> {
    var oppId = window.localStorage.getItem('oppId');
    var idToken = JSON.parse(window.localStorage.getItem('token') || "").id_token;
    const headers = new HttpHeaders()
      .append('appname', environment.appName)
      // .append("skip_interceptor", "true")
      .append('Authorization', 'Bearer ' + idToken);
    const data = {
      oppId: oppId,
      loginDate: moment().format("YYYY-MM-DD")
    }
    return this.http.post<{ results: any[] }>(`${environment.baseUrl}v1/submission/getScoreResponseByOppId`, { ...data }, { headers }).pipe(
      catchError(this.handleError)
    );

  }
  getClientAccessToken(cardId: string): Observable<any> {
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    var otpToken = window.localStorage.getItem("otp_token")
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      // .append('skip_interceptor', 'true')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken)
      .append("otp-authorization", "Bearer " + otpToken);
    let params = new HttpParams().append("cardId", cardId);
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(
        `${environment.baseUrl}v1/revenued/clientAccessToken`,
        { params, headers, responseType: "text" as "json" }
      )
    //.pipe(catchError(this.handleError));
  }

  getRevenuedActivateCard(cardId: string): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    var otpToken = window.localStorage.getItem("otp_token");

    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      // .append('skip_interceptor', 'true')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken)
      .append("otp-authorization", "Bearer " + otpToken);
    let params = new HttpParams().append("cardId", cardId);
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(
        `${environment.baseUrl}v1/revenued/RevenuedActivateCard/${oppId}`,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }

  getRevenuedSuspendCard(cardId: string): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    var otpToken = window.localStorage.getItem("otp_token");

    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      // .append('skip_interceptor', 'true')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken)
      .append("otp-authorization", "Bearer " + otpToken);
    let params = new HttpParams().append("cardId", cardId);
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/RevenuedSuspendCard`, {
        params,
        headers,
        responseType: "text" as "json",
      })
      .pipe(catchError(this.handleError));
  }

  getRevenuedCards(): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      // .append('skip_interceptor', 'true')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams();
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(
        `${environment.baseUrl}v1/revenued/RevenuedGetCards/${oppId}`,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }

  getQuickViewNotifications(): Observable<any> {
    var oppId = window.localStorage.getItem('oppId');
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      .append('appname', window.localStorage.getItem('appName') || "")
    let params = new HttpParams()
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/getQuickViewNotifications/${oppId}`, { params, headers, responseType: 'text' as 'json' }).pipe(
      catchError(this.handleError)
    );
  }
  updateMetadata(data: any) {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = {
      appname: environment.appName,
      Authorization: "Bearer " + idToken,
      skip_interceptor: "true",
    };
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .post<{ results: any[] }>(`${environment.baseUrl}v1/authentication/updateUserMetaData`, data, {
        headers,
      })
      .pipe(catchError(this.handleError));
  }
  getCoverDashMarketPlaceList(businessId: any): Observable<any> {
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .append('skip_interceptor', 'true')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams();
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .post<{ results: any[] }>(
        `${environment.baseUrl}v1/revenued/getCoverDashPolicies`,
        { businessId },
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }

  getMarketPlaceList(): Observable<any> {
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      // .append('skip_interceptor', 'true')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams();
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(
        `${environment.baseUrl}v1/revenued/getMarketPlaceList`,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }
  getEnvVariables(): Observable<any> {
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      // .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      .append('appname', environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
    return this.http.get<{ results: any[] }>('/api/env', { params, headers }).pipe(
      catchError(this.handleError)
    );
  }


  createCoverDashConversionEvent(data: any): Observable<any> {
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      // .append('skip_interceptor', 'true')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams();
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http.post<{ results: any[] }>(`${environment.baseUrl}v1/revenued/createCoverDashConversionEvent`, { ...data }, { headers }).pipe(
      catchError(this.handleError)
    );
  }


  createMarketplaceEvent(data: any): Observable<any> {
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      // .append('skip_interceptor', 'true')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams();
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http.post<{ results: any[] }>(`${environment.baseUrl}v1/revenued/createMarketplaceEvent`, { ...data }, { headers }).pipe(
      catchError(this.handleError)
    );
  }
  createCoverDashApplication(data: any): Observable<any> {
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      // .append('skip_interceptor', 'true')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams();
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .post<{ results: any[] }>(
        `${environment.baseUrl}v1/revenued/createCoverDashApplication`,
        data,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }


  getUnreadFlyNotifications(): Observable<any> {
    var oppId = window.localStorage.getItem('oppId');
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      .append('appname', window.localStorage.getItem('appName') || "")
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/getUnreadFlyNotifications/${oppId}`, { params, headers, responseType: 'text' as 'json' }).pipe(
      catchError(this.handleError)
    );
  }

  getAllNotifications(): Observable<any> {
    var oppId = window.localStorage.getItem('oppId');
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      .append('appname', window.localStorage.getItem('appName') || "")
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams()
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/getAllNotifications/${oppId}`, { params, headers, responseType: 'text' as 'json' }).pipe(
      catchError(this.handleError)
    );
  }

  getAccountSettingPermissions(): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      .append("skip_interceptor", "true")
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    //   let params = new HttpParams().append("oppId", oppId);
    let params = new HttpParams();
    if (oppId !== null) {
      params = params.append("oppId", oppId);
    }
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(
        `${environment.baseUrl}v1/revenued/getAccountSettingPermissions`,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }

  // markAsRead
  markNotificationRead(id: string): Observable<any> {
    var idToken = JSON.parse(window.localStorage.getItem('token') || "").id_token;
    var oppId = window.localStorage.getItem('oppId');
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      .append('appname', window.localStorage.getItem('appName') || "")
      .append('Authorization', 'Bearer ' + idToken);
    let params = new HttpParams()
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/markAsRead/${oppId}/${id}`, { params, headers, responseType: 'text' as 'json' }).pipe(
      catchError(this.handleError)
    );
  }
  setFirstLogin(): Observable<any> {
    var oppId = window.localStorage.getItem('oppId');
    var idToken = JSON.parse(window.localStorage.getItem('token') || "").id_token;
    const headers = new HttpHeaders()
      .append('appname', window.localStorage.getItem('appName') || "")
      .append("skip_interceptor", "true")
      .append('Authorization', 'Bearer ' + idToken);
    const data = {
      oppId: oppId,
      loginDate: moment().format("YYYY-MM-DD")
    }
    return this.http.post<{ results: any[] }>(`${environment.baseUrl}v1/revenued/setFirstLogin`, { ...data }, { headers }).pipe(
      catchError(this.handleError)
    );

  }

  needsBankRelink(): Observable<any> {
    var oppId = window.localStorage.getItem("oppId");
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      .append("skip_interceptor", "true")
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    // let params = new HttpParams().append("oppId", oppId);
    let params = new HttpParams();
    if (oppId !== null) {
      params = params.append("oppId", oppId);
    }
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/needsBankRelink`, {
        params,
        headers,
        responseType: "text" as "json",
      })
      .pipe(catchError(this.handleError));
  }


  getDirectMerchantTermAndFactor(oppId: string): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      // .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      // .append('appname',environment.appName)
      .append('Authorization', 'Bearer ');
    let params = new HttpParams()
      .append('oppId', oppId)
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/getDirectMerchantTermAndFactor`, { params, headers, responseType: 'text' as 'json' }).pipe(
      catchError(this.handleError)
    );
  }

  getTermAndFactorDirect(oppId: string | number | boolean): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Methods', 'GET')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Origin', '*')
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      // .append('appname', window.localStorage.getItem('appName'))
      .append('Authorization', 'Bearer ');
    let params = new HttpParams()
      .append('oppId', oppId)
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/getDirectTermAndFactor`, { params, headers, responseType: 'text' as 'json' }).pipe(
      catchError(this.handleError)
    );
  }

  getTermAndFactor(): Observable<any> {
    var oppId = window.localStorage.getItem('oppId');
    var idToken = JSON.parse(window.localStorage.getItem('token') || "").id_token;
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      .append('appname', window.localStorage.getItem('appName') || "")
      .append('Authorization', 'Bearer ' + idToken);
    // let params = new HttpParams()
    //   .append('oppId', oppId)
    let params = new HttpParams();
    if (oppId !== null) {
      params = params.append("oppId", oppId);
    }
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/getTermAndFactor`, { params, headers, responseType: 'text' as 'json' }).pipe(
      catchError(this.handleError)
    );
  }

  hasKYCStips(): Observable<any> {
    var oppId = window.localStorage.getItem('oppId');
    var idToken = JSON.parse(window.localStorage.getItem('token') || "").id_token;
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      .append('appname', window.localStorage.getItem('appName') || "")
      .append('Authorization', 'Bearer ' + idToken);
    // let params = new HttpParams()
    //   .append('oppId', oppId)
    let params = new HttpParams();
    if (oppId !== null) {
      params = params.append("oppId", oppId);
    }
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/hasKYCStips`, { params, headers, responseType: 'text' as 'json' }).pipe(
      catchError(this.handleError)
    );
  }

  gettRewardsTerms(): Observable<any> {
    var oppId = window.localStorage.getItem('oppId');
    var idToken = JSON.parse(window.localStorage.getItem('token') || "").id_token;
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      .append('appname', window.localStorage.getItem('appName') || "")
      .append('Authorization', 'Bearer ' + idToken);
    // let params = new HttpParams()
    //   .append('oppId', oppId)
    let params = new HttpParams();
    if (oppId !== null) {
      params = params.append("oppId", oppId);
    }
    const endpoint = this.gatewayConfigService.getApiEndpoint('gettRewardsTerms', null);

    return this.http.get<{ results: any[] }>(endpoint, { params, headers, responseType: 'text' as 'json' }).pipe(
      catchError(this.handleError)
    );
  }

  getRewards(): Observable<any> {
    var oppId = window.localStorage.getItem('oppId');
    var idToken = JSON.parse(window.localStorage.getItem('token') || "").id_token;
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      .append('Access-Control-Allow-Methods', 'GET')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Origin', '*')
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      .append('appname', window.localStorage.getItem('appName') || "")
      .append('Authorization', 'Bearer ' + idToken);
    // let params = new HttpParams()
    //   .append('oppId', oppId)
    let params = new HttpParams();
    if (oppId !== null) {
      params = params.append("oppId", oppId);
    }
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/getRewards`, { params, headers, responseType: 'text' as 'json' }).pipe(
      catchError(this.handleError)
    );
  }
  logoutUser(): Observable<any> {
    var idToken = window.localStorage.getItem('token') ? JSON.parse(window.localStorage.getItem('token') || '').id_token : '';
    var accessToken = window.localStorage.getItem('token') ? JSON.parse(window.localStorage.getItem('token') || "").access_token : '';
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      .append('appname', environment.appName)
      .append("skip_interceptor", "true")
      .append('Authorization', 'Bearer ' + idToken)
      .append('access_token', accessToken)
      .append('id_token', idToken);
    return this.http.post(`${environment.baseUrl}v1/authentication/logoutUser`, '', { headers });
  }

  redeemRewards(caseId: string | number | boolean, amount: string | number | boolean): Observable<any> {
    var oppId = window.localStorage.getItem('oppId');
    var idToken = JSON.parse(window.localStorage.getItem('token') || "").id_token;
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      .append('Access-Control-Allow-Methods', 'POST')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Origin', '*')
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      .append('appname', window.localStorage.getItem('appName') || "")
      .append('Authorization', 'Bearer ' + idToken);
    // let params = new HttpParams()
    //   .append('oppId', oppId)
    //   .append('caseId', caseId)
    //   .append('amount', amount)
    let params = new HttpParams();

    if (oppId !== null) { params = params.append('oppId', oppId); }
    if (caseId !== null) { params = params.append('caseId', caseId); }
    if (amount !== null) { params = params.append('amount', amount); }
    return this.http.get<{ results: any[] }>(`${environment.baseUrl}v1/revenued/redeemRewards`, { headers, params, responseType: 'text' as 'json' }).pipe(
      catchError(this.handleError)
    );
  }


  getTransactionDetail(tid: any): Observable<any> {
    var idToken = JSON.parse(window.localStorage.getItem("token") || "").id_token;
    const headers = new HttpHeaders()
      .set("Content-Type", "text/xml")
      // .append('skip_interceptor', 'true')
      .append("Access-Control-Allow-Methods", "GET")
      .append("Access-Control-Allow-Origin", "*")
      .append(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"
      )
      .append("appname", environment.appName)
      .append("Authorization", "Bearer " + idToken);
    let params = new HttpParams();
    //custom-error-handling (skip global interceptor using header tag - skip_interceptor : true
    return this.http
      .get<{ results: any[] }>(
        `${environment.baseUrl}v1/revenued/transactiondetail/${tid}`,
        { params, headers, responseType: "text" as "json" }
      )
      .pipe(catchError(this.handleError));
  }

  acceptOffer(oppId: string, offerId: string, body: any): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      .append('skip_interceptor', 'true')
      .append('Accept', 'application/json, text/plain, */*')
      .append('appname', 'RevenuedUAT');

    const params = new HttpParams()
      .append('oppId', oppId)
      .append('offerId', offerId);

    return this.http.post(`${environment.baseUrl}v1/revenued/acceptOffer`, body, { params, headers })
      .pipe(catchError(this.handleError));
  }

  validateEmail(email: string): Observable<{
    isValid: boolean;
    error?: string;
    isDisposable?: boolean;
    isConnected?: boolean;
  }> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      .append('appname', window.localStorage.getItem('appName') || "");

    const body = {
      email: email
    };

    return this.http.post<any>(`${environment.baseUrl}v1/revenued/validateEmail`, body, { headers }).pipe(
      map(response => {
        // Handle the response from the middleware endpoint
        return {
          isValid: response.deliverability === 'DELIVERABLE',
          error: undefined,
          isDisposable: response.is_disposable_email?.value || false,
          isConnected: response.deliverability === 'DELIVERABLE',
        };
      }),
      catchError(error => {
        console.error('Email validation error:', error);
        // Return valid response even on error
        return of({
          isValid: true,
          error: undefined,
          isDisposable: false,
          isConnected: true
        });
      })
    );
  }

  /**
   * Fetch offer options data from API endpoint
   */
  fetchOfferOptionsFromAPI(): Observable<OfferOptionsData> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'text/xml')
      // .append("skip_interceptor", "true")
      .append('Access-Control-Allow-Methods', 'GET')
      .append('Access-Control-Allow-Origin', '*')
      .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method")
      // .append('appname',environment.appName)
      .append('Authorization', 'Bearer ');

    return this.http.get<OfferOptionsApiResponse>(`${environment.baseUrl}v1/cache/fetchOfferOptionsTableData`, { headers }).pipe(
      tap((response) => {
        console.log('Raw API response:', response);
      }),
      // Validate response status
      tap((response) => {
        if (response.status !== 'success') {
          throw new Error(`API response status is not success: ${response.status}`);
        }
      }),
      // Map to just the data portion
      map((response) => response.data),
      catchError((error) => {
        console.error('API request failed:', error);
        // Throw error to be caught by caller
        throw error;
      })
    );
  }

  setPrepayResult(val: any) {
    this.prepayResult$.next(val);
  }

}
